angular.module('content.widgets.studentNotesWidgetService', [
])

/**
 * This services stores student notes until case is complete
 *
 * @class StudentNotesWidgetService
 * @constructor
 * @module content.widgets.StudentNotesWidgetService
 */
.factory('studentNotesWidgetService', [
  function () {
    'use strict';

    var service = {

      model: {
        label: 'Student Notes',
        notes: ''
      },

      setModel: function (model) {
        service.model = model;
      },

      setLabel: function (label) {
        service.model.label = label;
      },

      getModel: function () {
        return service.model;
      }
    };

    return service;
  }
]);
